import React, { useContext } from "react";
import { css } from "emotion";
import GenericCard from "../GenericCard";
import { boxStyles, textSizes, colors } from "../../styles/theme";
import Dropzone from "react-dropzone-uploader";
import BarLoader from 'react-spinners/BarLoader';
import spotlights from "../../services/api/spotlights";
import { BuildContext } from "../../context/BuildSpotlightState";
import { EditContext } from "../../context/EditSpotlightState";

const AudioFileUpload = ({ forEdit }) => {
  const { setFileName, setFileUrl, isLoading, setIsLoading, fileName } = useContext(
    forEdit ? EditContext : BuildContext
  );
  // specify upload params and url for your files

  const handleChangeStatus = async ({ meta, file }, status) => {
    if (status === "done") {
      setIsLoading(true);

      const formData = new FormData();
      formData.append("asset", file);

      try {
        const { data } = await spotlights.upload(formData);
        setIsLoading(false);

        setFileName(data.fileName);
        setFileUrl(data.fileUrl);
      } catch (error) {
        console.log(error);
      }
    }
  };

  // receives array of files that are done uploading when submit button is clicked
  return (
    <GenericCard style={container}>
      {!isLoading ? (
        <Dropzone
          onChangeStatus={handleChangeStatus}
          accept="audio/*"
          multiple={false}
          autoUpload={true}
          inputContent={fileName || "Drag File or Click to Browse"}
        />
        ) : (
          <BarLoader
            color={colors.brandColor}
          />
        )
      }
    </GenericCard>
  );
};

export default AudioFileUpload;

const container = css`
  width: 100%;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding: ${boxStyles.standardPadding};
  color: ${colors.brandColor};
  font-size: ${textSizes.normal};
  transition-duration: 0.2s;
  text-align: center;
  position: relative;
  min-height: 40px;
  cursor: pointer;

  .dzu-dropzone {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;

    .dzu-inputLabel {
      width: 100%;
      vertical-align: middle;
      padding: 10px 0;
      cursor: pointer;
    }

    .dzu-inputLabelWithFiles {
      display: none;
    }

    progress {
      display: none;
    }
  }

  .dzu-input {
    display: none;
  }

  &:hover {
    opacity: 0.8;
  }

  p {
    margin-left: 6px;
  }

  @media screen and (min-width: ${boxStyles.desktopBreak}) {
    width: 50%;
  }
`;
